
export const ORM_LIST_KEY = '@lists'
export const ORM_OBJECT_KEY = '@objects'
